export default function Avatar({

    src,

    name = "",

    size = 48,

    className = ""

}){

    const initials =

        name

            ?.trim()

            ?.split(" ")

            ?.filter(Boolean)

            ?.map(part=>part[0])

            ?.join("")

            ?.substring(0,2)

            ?.toUpperCase()

        ||

        "?";

    return(

        <div

            className={`crm-avatar ${className}`}

            style={{

                width:size,

                height:size

            }}

        >

            {

                src

                ?

                <img

                    src={src}

                    alt={name}

                />

                :

                <span>

                    {initials}

                </span>

            }

<style>{`

.crm-avatar{

    display:flex;

    align-items:center;

    justify-content:center;

    flex-shrink:0;

    border-radius:50%;

    overflow:hidden;

    background:linear-gradient(
        135deg,
        #2563EB,
        #3B82F6
    );

    color:#FFF;

    font-size:15px;

    font-weight:700;

    user-select:none;

}

.crm-avatar img{

    width:100%;

    height:100%;

    object-fit:cover;

    display:block;

}

.crm-avatar span{

    line-height:1;

}

`}</style>

        </div>

    );

}